module.exports = __webpack_public_path__ + "img/product_85.d5ea78a.svg";